export enum ResultStatus {
  Success = 'success',
  Error = 'error',
}

export type Result<TData = undefined, TMeta = undefined> =
  | {
      status: ResultStatus.Success;
      data?: TData;
      meta?: TMeta;
    }
  | {
      status: ResultStatus.Error;
      errors?: Record<string, string[]>;
      data?: TData;
      meta?: undefined;
      message?: string | string[];
    };
